import React, { useState, useContext, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { GlobalContext } from '../../../store/Store';
import  ActionType from '../../../store/ActionType';
import LayerIcon from '../../../icons/Layer.svg?react';
import CloseS from '../../../icons/CloseS.svg?react';
import UpArrow from '../../../icons/Up.svg?react';
import DownArrow from '../../../icons/Down.svg?react';
import EyeVisible from '../../../icons/EyeVisible.svg?react';
import EyeHidden from '../../../icons/EyeHidden.svg?react';
import ProviderIcon from '../../ProviderIcon';
import '../CommonStyle.css';
import './LayerManager.css';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import OlLayerVector from 'ol/layer/Vector';
import OlSourceVector from 'ol/source/Vector';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import OlView from 'ol/View';
import {
  zoomToMeshExtent,
  calcDelta,
  createFeature,
  createGridStyle,
} from '../../map/MapFunctions';
import MikeSpinner from '../../mike-spinner/MikeSpinner';

import Api from '../../../apis/meshApi';
import { showMeshTiles, cleanUpMeshTiles } from '../../map/MapFunctions';

import { getProviderXyCoords } from '../../app/apiFunctions';

function LayerManager({
  sidePanelState,
  onLayerSelected,
}: {
  sidePanelState: boolean;
  onLayerSelected: (layer: any) => void;
}) {
  const [activeLayerManager, setActiveLayerManager] = useState(false);
  const [selectedLayer, setSelectedLayer] = useState('0');
  const [selectedSetting, setSelectedSetting] = React.useState('default');
  const [showMeshBoundaries, setShowMeshBoundaries] = useState(true);
  const [showMesh, setShowMesh] = useState(true);
  const [showDataProviderGrids, setShowDataProviderGrids] = useState(false);
  const [showBaseMaps, setShowBaseMaps] = useState(true);
  const [showSettings, setShowSettings] = useState(true);

  // global store
  const [globalState, globalDispatch] = useContext(GlobalContext);
  const providers =
    globalState.data.extractionbuilderdata && globalState.data.extractionbuilderdata.providers
      ? globalState.data.extractionbuilderdata.providers
      : [];

  const changeBaseMap = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedLayer((event.target as HTMLInputElement).value);
    onLayerSelected(event.target.value);
  };

  let points = [];
  const vectorLayer = new OlLayerVector({    
    source: new OlSourceVector({}),
  });
  vectorLayer.set('title', 'meshGrid');
  vectorLayer.set('name', 'meshGrid')

  useEffect(() => {
    if (globalState.mesh.meshProjection) {
      setSelectedSetting('default');
      setShowMeshBoundaries(true);
      proj4.defs(globalState.mesh.meshProjectionWKT, globalState.mesh.meshProjection);
      register(proj4);
      return () => {
        console.log('DISMOUNT Layers');
        (globalState.map as any).olMap
          .getLayers()
          .getArray()
          .filter(layer => {
            return layer && layer.get('id') != undefined && layer.get('id') === 'providers';
          })
          .forEach(layer => {
            (globalState.map as any).olMap.removeLayer(layer);
            console.log('removing layers', layer);
          });
      };
    }
  }, [globalState.mesh.meshProjection, globalState.mesh.features]);

  const changeMapSettings = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedSetting((event.target as HTMLInputElement).value);
    if (
      (globalState.map as any).olMap
        .getView()
        .getProjection()
        .getCode() !== globalState.mesh.meshProjectionWKT
    ) {
      cleanUpMeshTiles(globalState);
      (globalState.map as any).olMap.setView(
        new OlView({
          projection: globalState.mesh.meshProjectionWKT,
        })
      );
      (globalState.map as any).olMap
        .getLayers()
        .getArray()
        .forEach(function(layer) {
          if (layer.getSource() && layer.getSource().forEachFeature) {
            layer.getSource().forEachFeature(function(feature) {
              feature.getGeometry().transform('EPSG:3857', globalState.mesh.meshProjectionWKT);
            });
          }
        });
      reprojectMeshTiles(false);
    } else {
      cleanUpMeshTiles(globalState);
      (globalState.map as any).olMap.setView(
        new OlView({
          projection: 'EPSG:3857',
        })
      );
      (globalState.map as any).olMap
        .getLayers()
        .getArray()
        .forEach(function(layer) {
          if (layer.getSource() && layer.getSource().forEachFeature) {
            layer.getSource().forEachFeature(function(feature) {
              feature.getGeometry().transform(globalState.mesh.meshProjectionWKT, 'EPSG:3857');
            });
          }
        });
      reprojectMeshTiles(true);
    }
    zoomToMeshExtent((globalState.map as any).olMap);
  };

  const getProviderXyCoordsData = async providerid => {
    return await getProviderXyCoords({
      projectID: globalState.project.currentProject.id,
      datasetGuid: providerid,
      meshName: globalState.mesh.meshName,
      modelType: globalState.mesh.modelType,
      globalDispatch,
    });
  };

  const showGridOnMap = (parentIndex: number, prov: object) => async () => {
    const itemVisible = globalState.data.extractionbuilderdata.providers[parentIndex].isVisible;
    globalState.data.extractionbuilderdata.providers[parentIndex].isVisible = !itemVisible;
    globalDispatch({
      type: ActionType.SET_DATA_EXTRACTION_BUILDER,
      data: globalState.data.extractionbuilderdata,
    });
    if ((prov as any).yAxisCoords === null || (prov as any).xAxisCoords === null) {
      const coords = await getProviderXyCoordsData((prov as any).id);
      drawGrid({...prov, xAxisCoords: coords.xAxisCoords, yAxisCoords: coords.yAxisCoords});
    }
    else{
       drawGrid(prov);
    }
   
  };

  const isLayerAddedToMap = prov => {
    let isLayer = false;
    (globalState.map as any).olMap
      .getLayers()
      .getArray()
      .filter(layer => {
        return layer && layer.get('name') != undefined && layer.get('name') === prov.name;
      })
      .forEach(() => {
        isLayer = true;
      });
    return isLayer;
  };

  const drawGrid = prov => {    
    if (isLayerAddedToMap(prov) !== true) {
      const providerGridVectorLayer = new OlLayerVector({    
        source: new OlSourceVector({}),
      });
      providerGridVectorLayer.set('name', prov.name);
      providerGridVectorLayer.set('id', 'providers');
      providerGridVectorLayer.setVisible(true)

      proj4.defs(prov.wkt, prov.proj4);
      register(proj4);

      const deltaYfloor = Math.floor(prov.yAxisCoords.length / calcDelta(prov.yAxisCoords.length));
      const deltaXfloor = Math.floor(prov.xAxisCoords.length / calcDelta(prov.xAxisCoords.length));
      const deltaY = deltaYfloor > 0 ? deltaYfloor : 1;
      const deltaX = deltaXfloor > 0 ? deltaXfloor : 1;

      for (let i = 0; i < prov.xAxisCoords.length; i++) {
        for (let ii = 0; ii < prov.yAxisCoords.length; ii = ii + deltaY) {
          points.push([prov.xAxisCoords[i], prov.yAxisCoords[ii]]);
        }
        points.push([prov.xAxisCoords[i], prov.yAxisCoords[prov.yAxisCoords.length - 1]]);
        const feature = createFeature(
          points,
          prov.wkt,
          (globalState.map as any).olMap
            .getView()
            .getProjection()
            .getCode()
        );
        feature.setStyle(createGridStyle(prov.color));
        providerGridVectorLayer.getSource().addFeature(feature);
        points = [];
      }

      for (let i = 0; i < prov.yAxisCoords.length; i++) {
        for (let ii = 0; ii < prov.xAxisCoords.length; ii = ii + deltaX) {
          points.push([prov.xAxisCoords[ii], prov.yAxisCoords[i]]);
        }
        points.push([prov.xAxisCoords[prov.xAxisCoords.length - 1], prov.yAxisCoords[i]]);
        const feature = createFeature(
          points,
          prov.wkt,
          (globalState.map as any).olMap
            .getView()
            .getProjection()
            .getCode()
        );
        feature.setStyle(createGridStyle(prov.color));
        providerGridVectorLayer.getSource().addFeature(feature);
        points = [];
      }

      (globalState.map as any).olMap.addLayer(providerGridVectorLayer);
    } else {
      (globalState.map as any).olMap
        .getLayers()
        .getArray()
        .filter(layer => {
          return layer && layer.get('name') != undefined && layer.get('name') === prov.name;
        })
        .forEach(layer => {
          layer.setVisible(!layer.getVisible());
        });
    }
  };

  const cleanAll = () => {
    //THERE IS A BUG WHEN NEW PROJECT IS SELECTED. ALL TOGGLE OF VISIBILITY ON LAYERS SHOWES A WHITE EMPTY LAYER ON TOP
    //THIS CLEAN-ALL IS FOR FINDING THE BUG
    (globalState.map as any).olMap
      .getLayers()
      .getArray()
      .filter(l => {
        return l.get('id') === 'providers';
      })
      .forEach(layer => {
        console.log('cleaning layers', layer);
        layer
          .getSource()
          .getFeatures()
          .forEach(feature => {
            layer.getSource().removeFeature(feature);
          });
      });
  };

  const toggleMeshBoundaries = () => {
    const getMeshBoundaries = (globalState.map as any).olMap
      .getLayers()
      .getArray()
      .filter(b => {
        return b.get('name') === 'meshBoundaries';
      });

    if (getMeshBoundaries && getMeshBoundaries.length === 1) {
      setShowMeshBoundaries(!showMeshBoundaries);
      getMeshBoundaries[0].setVisible(!showMeshBoundaries);
    }
  };

  const toggleMesh = () => {
    const getMesh = (globalState.map as any).olMap
      .getLayers()
      .getArray()
      .filter(b => {
        return b.get('name') === 'meshtilefeatures';
      });

    if (getMesh && getMesh.length === 1) {
      setShowMesh(!showMesh);
      getMesh[0].setVisible(!showMesh);
    }
  };

  const reprojectMeshTiles = async (reproject: boolean) => {
    try {
      const response = await Api.getTileGridConfig(
        globalState.project.currentProject.projectGuid,
        globalState.mesh.meshName,
        reproject
      );
      globalDispatch({
        type: ActionType.SET_MESH_TILEGRID_CONFIG,
        data: JSON.parse(response.data),
      });
      showMeshTiles(globalState, globalDispatch, JSON.parse(response.data), reproject);
    } catch (e) {
      console.log('error: ', e.message);
    }
  };

  return (
    <>
      <div
        className={
          activeLayerManager
            ? 'LayerManager active' + ' ' + (sidePanelState ? 'sidePanelOpen' : '')
            : 'LayerManager' + ' ' + (sidePanelState ? 'sidePanelOpen' : '')
        }>
        {/* <Tooltip title="Layer manager"> */}
          <LayerIcon
            className="openLayerManager"
            onClick={() => setActiveLayerManager(!activeLayerManager)}
          />
        {/* </Tooltip> */}
        <CloseS
          className="closeLayerManager"
          onClick={() => setActiveLayerManager(!activeLayerManager)}
        />

        {activeLayerManager && (
          <>
            <Typography variant="h3">
              <span onClick={() => cleanAll()}>Layers</span>
            </Typography>
            <div className="LayerManagerContent scrollableContent">
              <div className="layerGroup">
                <div className="layerGroupTitle">
                  Mesh boundaries
                  {showMeshBoundaries && (
                    <EyeVisible className="eyeVisible" onClick={() => toggleMeshBoundaries()} />
                  )}
                  {!showMeshBoundaries && (
                    <EyeHidden className="eyeHidden" onClick={() => toggleMeshBoundaries()} />
                  )}
                </div>
              </div>

              <div className="layerGroup">
                <div className="layerGroupTitle" onClick={() => toggleMesh()}>
                  Mesh
                  {globalState.mesh.meshTileGridProcess ? (
                    <div className="layerManagerSpinner">
                      <MikeSpinner size="xs" />
                    </div>
                  ) : showMesh ? (
                    <EyeVisible className="eyeVisible" />
                  ) : (
                    <EyeHidden className="eyeHidden" />
                  )}
                </div>
              </div>

              <div className="layerGroup">
                <div
                  className="layerGroupTitle"
                  onClick={
                    !globalState.data.fetchingExtractionBuilderData
                      ? () => setShowDataProviderGrids(!showDataProviderGrids)
                      : undefined
                  }>
                  Data provider grids
                  {showDataProviderGrids && <UpArrow />}
                  {globalState.data.fetchingExtractionBuilderData && !showDataProviderGrids ? (
                    <div className="layerManagerSpinner">
                      <MikeSpinner size="xs" />
                    </div>
                  ) : !showDataProviderGrids ? (
                    <DownArrow />
                  ) : null}
                </div>

                <div className={showDataProviderGrids ? '' : 'hideLayerGroup'}>
                  {providers &&
                    providers.map((prov, i) => (
                      <div className={prov.isVisible ? 'showProvider' : 'hideProvider'} key={i}>
                        <div className="panelItem itemBorder noPadding">
                          <div className="contentFlex">
                            <div className="panelItemIcon">
                              <ProviderIcon provider={prov} />
                            </div>
                            <div className="panelItemContent">{prov.displayName}</div>
                            {prov.isAnalytical !== true ? (
                              <div className="toggleItemVisibility">
                                {prov.isVisible ? (
                                  <EyeVisible
                                    className="eyeVisible"
                                    onClick={showGridOnMap(i, prov)}
                                  />
                                ) : (
                                  <EyeHidden
                                    className="eyeHidden"
                                    onClick={showGridOnMap(i, prov)}
                                  />
                                )}
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              <div className="layerGroup">
                <div className="layerGroupTitle" onClick={() => setShowBaseMaps(!showBaseMaps)}>
                  Base maps
                  {showBaseMaps && <UpArrow />}
                  {!showBaseMaps && <DownArrow />}
                </div>

                <div className={showBaseMaps ? '' : 'hideLayerGroup'}>
                  <FormControl component="fieldset">
                    <RadioGroup value={selectedLayer} onChange={changeBaseMap}>
                      <FormControlLabel
                        value={'0'}
                        control={<Radio color="primary" />}
                        label="MapTiler Satellite"
                      />
                      <FormControlLabel
                        value={'1'}
                        control={<Radio color="primary" />}
                        label="MapTiler Hybrid"
                      />
                      <FormControlLabel
                        value={'2'}
                        control={<Radio color="primary" />}
                        label="OpenStreetMap"
                      />
                      <FormControlLabel
                        value={'3'}
                        control={<Radio color="primary" />}
                        label="No base map"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>

              <div className="layerGroup">
                <div className="layerGroupTitle" onClick={() => setShowSettings(!showSettings)}>
                  Settings
                  {showSettings && <UpArrow />}
                  {!showSettings && <DownArrow />}
                </div>

                <div className={showSettings ? '' : 'hideLayerGroup'}>
                  <FormControl component="fieldset">
                    <RadioGroup value={selectedSetting} onChange={changeMapSettings}>
                      <FormControlLabel
                        value={'default'}
                        control={<Radio color="primary" />}
                        label="Web mercator (EPSG:3857)"
                      />
                      <FormControlLabel
                        value={'custom'}
                        control={<Radio color="primary" />}
                        label={
                          'Mesh Projection (' +
                          (globalState.mesh.meshProjectionShortname === null
                            ? 'None'
                            : globalState.mesh.meshProjectionShortname) +
                          ')'
                        }
                        disabled={globalState.mesh.meshProjectionShortname === null ? true : false}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
export default React.memo(LayerManager);
